var _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 192,
    viewBox: "0 0 215 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 148.5,
    r: 31,
    stroke: "#40956F",
    strokeWidth: 25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 58.5,
    stroke: "#B1CF5F",
    strokeOpacity: 0.95,
    strokeWidth: 25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 98,
    r: 38.5,
    stroke: "#B1CF5F",
    strokeOpacity: 0.95,
    strokeWidth: 25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/LogoIcon.e002ba27a8424febc1edad25deff83a8.svg";
export { ForwardRef as ReactComponent };